import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_RandomizedQuickSort = () => (
  <DAAModuleSubtopic
    title="Randomized Algorithms - Randomized QuickSort"
    videos={[
      "https://www.youtube.com/embed/JBLLtV2it2w",
      "https://www.youtube.com/embed/aFswaBnWKLk",
      "https://www.youtube.com/embed/a6eB8aRHRm4",
      "https://www.youtube.com/embed/nUlEfx-HgII"
    ]}
    takeaways={[
      {
        text: "Randomized algorithms introduce randomness to avoid worst-case scenarios like O(n²) in QuickSort."
      },
      {
        text: "Randomized QuickSort selects a pivot randomly, reducing dependency on input order and improving average case performance."
      },
      {
        text: "Expected time complexity of Randomized QuickSort: O(n log n)."
      },
      {
        text: "Space complexity remains O(log n) due to in-place recursive partitioning."
      },
      {
        text: "Useful for input-independent and high-performance applications in real-time systems and data processing."
      }
    ]}
    questions={[
      {
        text: "Narrate how the Randomized QuickSort algorithm differs from the Normal QuickSort. Write the algorithm and solve it with an example."
      },
      {
        text: "Illustrate the need for randomized algorithms. Demonstrate the working of a randomized version of QuickSort with an appropriate example."
      },
      {
        text: "Explain how randomization helps prevent worst-case behavior in sorting algorithms."
      },
      {
        text: "Derive and explain the expected time complexity of Randomized QuickSort using recurrence relation."
      }
    ]}
    exampleVideos={[]}
  />
);

export default DAA_RandomizedQuickSort ;
